module.exports = __webpack_public_path__ + "img/PPMP28.c7953ab4.png";